import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';
import { LdAccountLimits } from 'src/app/shared/enums/limits-ld-account-settings.enum';

export type LinkedinLimitsData = {
  views: number;
  likes: number;
  requests: number;
  messages: number;
  inMail: number;
  withdrawLimit: number;
};

@Component({
  selector: 'app-linkedin-account-limits-modal',
  templateUrl: './linkedin-account-limits-modal.component.html',
  styleUrls: ['../shared/edit-modal-styles.scss', './linkedin-account-limits-modal.component.scss'],
  standalone: false,
})
export class LinkedinAccountLimitsModalComponent implements OnInit, OnDestroy {
  constructor(
    public dialogRef: MatDialogRef<LinkedinAccountLimitsModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data?: LinkedinLimitsData,
  ) {}

  private initialStringifiedValue: string = '';

  limits = LdAccountLimits;
  $unsubscribe = new Subject<void>();
  saveDisabledSubject = new BehaviorSubject<boolean>(true);

  formGroup = new FormGroup({
    views: new FormControl<number>(10),
    likes: new FormControl<number>(10),
    requests: new FormControl<number>(10),
    messages: new FormControl<number>(10),
    inMail: new FormControl<number>(10),
    withdrawLimit: new FormControl<number>(0),
  });

  closeModal(): void {
    this.dialogRef.close(null);
  }

  save(): void {
    const settings = this.formGroup.getRawValue();
    this.dialogRef.close(settings);
  }

  ngOnInit(): void {
    this.formGroup.patchValue(this.data);
    this.handleSaveButtonState();
  }

  private handleSaveButtonState(): void {
    this.initialStringifiedValue = JSON.stringify(this.formGroup.getRawValue());

    this.formGroup.valueChanges.pipe(takeUntil(this.$unsubscribe)).subscribe((formValue) => {
      const saveDisabled =
        JSON.stringify(this.formGroup.getRawValue()) === this.initialStringifiedValue;

      this.saveDisabledSubject.next(saveDisabled);
    });
  }

  ngOnDestroy(): void {
    this.$unsubscribe.next();
    this.$unsubscribe.complete();
  }
}
